<!--
 * anthor: yangshaobo
 * createDate: 2021/02/04
 * updateDate: 2021/03/24
-->
<template>
  <div>
    <div v-if="!hideSelectInput">
      <Input
        readonly
        class="inputDisabled"
        :value="handleValue"
        v-show="(actionType == 'add' && disabled) || (actionType == 'update' && disabled)"
        disabled>
      </Input>
      <Input
        @on-change="onChange"
        :readonly="readonly"
        :value="handleValue" 
        v-show="!disabled">
        <span slot="append" @click="onShowTree" class="iv-pointer" v-show="scopeEdit">选择</span>
      </Input>
    </div>
    <AuthMember
      ref="authMember"
      v-if="isAccurate"
      :listData="listData"
      :listUrl="listUrl"
      :map="listMap"
      :showPage="showPage"
      :title="modalTitle"
      :defaultValue="value"
      @on-process-data="onProcessData"
    ></AuthMember>
    <Modal
      v-else
      closeText="确定"
      ref="Modal"
      :title="modalTitle"
      :size="showTree ? 'large' : 'small'"
      @on-ok="onOK"
      @on-cancel="hidedenModal"
      @on-visible="visibleModal">
      <ModalLayout v-if="showContent">
        <tagGroup
          v-if="showType === 'checkbox'"
          :list="checkListLable"
          class="iv-m-b-16"
          @onClose="onTagClose" />
        <Row class="iv-select-wrapper">
          <div class="iv-body-wrapper">
            <Col
              v-if="showTree"
              span="12"
              :class="showPage ? 'iv-select-treelistProps iv-symbol-p16' : 'iv-select-tree iv-symbol-p16'">
              <LazyTree
                ref="LazyTree"
                :async="async"
                v-bind="$attrs"
                :changeTree="false"
                :treeMap="treeMap"
                :treeParams="treeData"
                :treeUrl="treeUrl"
                :treeStyle="{'overflow-y': 'scroll', 'max-height': '355px', 'height': '355px;'}"
                @on-select-change="onSelectChange">
              </LazyTree>
            </Col>
            <Col
              :span="showTree ? 12 : 24"
              class="iv-p-t-16 iv-p-l-16 iv-p-r-16">
              <div class="iv-member-list" :class="showTree ? 'iv-select-list' : 'iv-select-half'">
                <div class="iv-select-list-body">
                  <RadioGroup
                    v-model="selectSearchMod"
                    v-if="showSearchInput && selectUserSwitch"
                    class="iv-m-b-12"
                    @on-change="onSelectUserChange"
                    style="width: 100%">
                    <Radio label="DUTY_USER" style="width: 45%" :disabled="isGrayDutyUser">
                      <span>本级委员会成员</span>
                    </Radio>
                    <Radio label="PARTY_USER" style="width: 45%">
                      <Input
                        style="width: 100%;"
                        clearable
                        v-if="showSearchInput"
                        @keyup.enter.native="searchPeople"
                        @on-focus="() => {
                          this.selectSearchMod = 'PARTY_USER'
                          this.onSelectUserChange()
                          // this.selectSearchMod = 'PARTY_USER'
                        }"
                        :placeholder="placeholder"
                        v-model="userName"
                      />
                    </Radio>
                  </RadioGroup>
                  <Input
                    class="iv-m-b-12"
                    style="width: 100%;"
                    clearable
                    v-if="showSearchInput && !selectUserSwitch"
                    @keyup.enter.native="searchPeople"
                    :placeholder="placeholder"
                    v-model="userName"
                  />
                  <div v-if="subAllSelectList.length > 0" style="overflow-y: scroll; max-height: 290px">
                    <div style="padding-bottom: 6px; margin-bottom: 6px;">
                      <Checkbox
                        :indeterminate="indeterminate"
                        v-model="checkAll"
                        v-if="showType === 'checkbox'"
                        @click.prevent.native="handleCheckAll">全选</Checkbox>
                      <CheckboxGroups
                        ref="checkboxComp"
                        v-if="listProps.type === 'checkbox'"
                        :value="checkList"
                        :list="subAllSelectList"
                        :allList="allSelectList"
                        :selectUserSwitch="selectUserSwitch"
                        @on-check-change="onCheckBoxChange"
                      >
                      </CheckboxGroups>
                      <RadioGroups
                        v-else
                        :value="checkList"
                        :list="subAllSelectList"
                        :allList="allSelectList"
                        :selectUserSwitch="true"
                        @on-radio-change="onRadioBoxChange"
                      ></RadioGroups>
                    </div>
                  </div>
                  <div v-else>
                    {{ pageTips.noData }}
                  </div>
                </div>
              </div>
              <Page
                v-if="showPage"
                :show-elevator="false"
                :show-sizer="false"
                :current="currentPage"
                size="small"
                :showGo="false"
                :total="count"
                :pageSize="pageSize"
                @on-change="onPageChange"
                @on-page-size-change="onPageSizeChange"
              ></Page>
            </Col>
          </div>
        </Row>
      </ModalLayout>
    </Modal>
  </div>
</template>

<script>
import AuthMember from './auth/member'
import LazyTree from '@/components/lazy-tree'
import Page from '@/components/page'
import Modal from '@/components/modal'
import ModalLayout from '@/components/modal/layout'
import tagGroup from '@/components/tag-group'
import { cloneDeep } from 'lodash'
import CheckboxGroups from './checkbox'
import RadioGroups from './radio'

export default {
  props: {
    // 是否显示input选择按钮
    hideSelectInput: {
      type: Boolean,
      default: false
    },
    // 操作类型
    actionType: {
      type: String,
      default: 'add'
    },
    // 是否不可编辑
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, String],
      default () {
        return ''
      }
    },
    // 右侧不显示的数据列表
    disabledList: {
      type: Array,
      default () {
        return []
      }
    },
    // 是否只读
    readonly: {
      type: Boolean,
      default: true
    },
    // props传参
    listProps: {
      type: Object,
      default () {
        return {}
      }
    },
    props: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      pageTips: { // 页面静态文字
        noData: '暂无可选人员'
      },
      isExpand: true, // 是否执行expand
      showSearchInput: true, // 是否显示输入框
      searchKey: '', // input搜索key
      showPage: true, // 是否显示分页
      currentPage: 1, // 当前页
      count: 0, // 数据条数
      pageSize: 10, // 每页条数
      showTree: true, // 是否显示树
      async: true, // 是否异步
      treeMap: {}, // 异步树参数
      treeData: {}, // 树参数
      treeUrl: '', // 同步树url
      scopeEdit: true, // 权限
      handleValue: '', // input框中文字
      modalTitle: '', // 模态框title
      listMap: {
        value: 'userId',
        title: 'userName'
      }, // 操作数据转换map
      checkList: [], // 选择的数据
      checkListLable: [], // tag 列表
      allSelectList: [], // 返回的数据
      allResultData: [], // 所有的数据
      subAllSelectList: [], // 右侧列表数据
      listUrl: '', // 右侧接口
      listData: {}, // 右侧接口请求数据
      method: 'GET', // 右侧接口请求方式
      placeholder: '输入后回车搜索',
      userName: '', // 搜索值
      currOrgId: '', // 当前机构id
      currOrgName: '', // 当前机构名称
      selectData: [], // 当前选择的data
      showType: 'checkbox', // 操作类型
      checkAll: false,
      indeterminate: false, // 全选是否选中
      selectUserSwitch: false, // 选人
      globalConfig: {}, // 全局配置项
      isCanEmptySearch: false, // 是否可以无条件搜索
      selectSearchMod: '', // 右侧列表筛选方式
      showContent: false, // 用于延迟显示数据
      oldNoData: '',
      isGrayDutyUser: false, // 是否本级委员会成语不可选
      isAccurate: false, // 是否为精确查找（用于全树选人）
      orgId: ''
    }
  },
  components: { AuthMember, LazyTree, Page, Modal, ModalLayout, tagGroup, CheckboxGroups, RadioGroups },
  created () {
    // 初始化右侧基本数据
    this.initPageSetting()
    // 初始化回显
    this.initShowSetting()
    // 初始化树
    this.initTreeSetting()
    this.isAccurate = this.isAccurateFun()
  },
  watch: {
    value: {
      handler (newVal) {
        if (Array.isArray(newVal)) {
          this.handleValue = newVal.map(item => item[this.listMap.title]).join(',')
        } else {
          this.handleValue = newVal
        }
        if (Array.isArray(newVal) && newVal.length) {
          this.checkListLable = newVal.map(item => item[this.listMap.title])
          this.checkList = this.showType === 'checkbox' ? newVal.map(item => item[this.listMap.value]) : newVal[0][this.listMap.value]
        }
        this.selectData = JSON.parse(JSON.stringify(newVal || []))
      },
      deep: true,
      immediate: true
    },
    '$store.state.edit': {
      handler (val) {
        this.scopeEdit = val
      }
    },
    listProps: {
      handler () {
        // 初始化右侧基本数据
        this.initPageSetting()
        // 初始化回显
        this.initShowSetting()
        // 初始化树
        this.initTreeSetting()
      },
      deep: true
    }
    // selectSearchMod (result) {
    //   this.onSelectUserChange(result)
    // }
  },
  inject: {
    expandParent: {
      default () {
        return function () {}
      }
    }
  },
  methods: {
    onChange (e) {
      this.$emit('input', e.target.value)
    },
    // 初始化回显数据
    initShowSetting () {
      if (Array.isArray(this.value) && this.value.length) {
        this.checkListLable = this.value.map(item => item[this.listMap.title])
        this.checkList = this.showType === 'checkbox' ? this.value.map(item => item[this.listMap.value]) : this.value[0][this.listMap.value]
        this.selectData = JSON.parse(JSON.stringify(this.value))
      }
      this.handleValue = Array.isArray(this.value) ? this.value.map(item => item[this.listMap.title]).join(',') : this.value
    },
    // 初始化右侧基本数据
    initPageSetting () {
      this.modalTitle = this.listProps?.title || '选人'
      this.listMap = this.listProps?.map || {
        value: 'userId',
        title: 'userName'
      }
      this.$set(this.pageTips, 'noData', this.listProps?.pageTipsNodata || '暂无可选人员')
      this.showSearchInput = (this.listProps?.showSearchInput != undefined) ? this.listProps?.showSearchInput : true
      this.searchKey = this.listProps?.searchKey ? this.listProps?.searchKey : 'userName'
      this.showPage = (this.listProps?.showPage != undefined) ? this.listProps?.showPage : true
      this.isExpand = (this.listProps?.isExpand != undefined) ? this.listProps?.isExpand : true
      this.listUrl = this.listProps?.listUrl || this.getDefaultUrl()
      this.selectUserSwitch = this.listProps?.selectUserSwitch || false
      this.listData = Object.assign({bizLineCode: this.listProps?.bizLineCode || 'YWX01'}, this.listProps?.listData || {})
      this.method = this.listProps?.method || 'GET'
      this.showType = this.listProps?.type ? this.listProps?.type : 'checkbox'
      const idMap = {
        'YWX01': 'orgId',
        'YWX03': 'fullId',
        'YWX04': 'legId',
        'YWX06': 'planId',
        'YWX05': 'cultureId'
      }
      const bizLineCode = this.listProps?.bizLineCode || 'YWX01'
      this.orgId = sessionStorage.getItem(idMap[bizLineCode]) || ''
      // this.getConfigPage()
    },
    // 判断是否全树并且是精确查找
    isAccurateFun () {
      let isCustom = this.listProps.customList
      // let isRootId = (this.treeData.orgId == '-1') && (this.treeData.orgId != sessionStorage.getItem('listOrgId'))
      let isRootId = !!this.listProps.isRootOrgConfig // isRootOrgConfig: 是否配置的全树
      let isSelectMemberUrl = this.listUrl.includes('api-general/module/portal/user/listOrganizationUser') || this.listUrl.includes('module/user/getUserList')
      if (this.showTree && !isCustom && isRootId & isSelectMemberUrl) {
        return true
      }
      return false
    },
    // 获取全局选人配置
    async getConfigPage () {
      if (this.listProps?.sendAction) return
      if (this.listUrl.includes('api-general/module/portal/user/listOrganizationUser') || this.listUrl.includes('module/user/getUserList') || this.selectUserSwitch) {
        await this.$ajax({
          url: 'api-general/module/portal/user/global/getConfigGlobal',
          method: 'get',
          data: {
            bizLineCode: this.listProps?.bizLineCode || 'YWX01'
          }
        }).then((res) => {
          this.selectUserSwitch = true
          this.globalConfig = res.data.data
          // 判断是否发展中人员
          let u = this.listProps.listData && this.listProps.listData.userTypes
          let s = this.listProps.sendListData && this.listProps.sendListData().userTypes
          let isDevlopUser = (u || s) && ((u || s).includes(10) || (u || s).includes(20) || (u || s).includes(30))
          if ((this.listUrl || this.listProps.listUrl).includes('module/user/getUserList') && isDevlopUser) {
            this.selectSearchMod = 'PARTY_USER'
            this.isGrayDutyUser = true
            if ((sessionStorage.getItem('orgCategory') == this.$category.getDZB()) || (sessionStorage.getItem('orgCategory') == this.$category.getDXZ())) {
              this.isCanEmptySearch = true
              return
            }
            this.isCanEmptySearch = res.data.data.otherSearch === 1
            return
          }
          this.isGrayDutyUser = false
          if ((sessionStorage.getItem('orgCategory') == this.$category.getDZB()) || (sessionStorage.getItem('orgCategory') == this.$category.getDXZ())) {
            this.selectSearchMod = res.data.data.zbDutyType
            this.isCanEmptySearch = true
            return
          }
          this.selectSearchMod = res.data.data.otherDutyType
          this.isCanEmptySearch = res.data.data.otherSearch === 1
        })
      }
    },
    // 选人类型改变事件
    onSelectUserChange (result) {
      if (!this.$refs.Modal.showModal) return
      this.userName = ''
      this.count = 0
      this.subAllSelectList.length = 0
      this.currentPage = 1
      if (this.selectSearchMod == 'DUTY_USER') {
        this.$set(this.pageTips, 'noData', '当前党组织未维护当届换届信息')
        this.getListPageData()
        return
      }
      if (this.globalConfig.otherSearch === 2) {
        this.$set(this.pageTips, 'noData', '非党支部党组织查询时需要先输入查询条件')
      }
      this.isCanEmptySearch && this.searchPeople()
    },
    // 初始化树
    initTreeSetting () {
      this.showTree = (this.listProps?.showTree != undefined) ? this.listProps?.showTree : true
      this.treeMap = this.listProps?.treeMap || {
        key: 'orgId'
      }
      this.treeData = this.listProps?.treeData || {
        scope: 2,
        orgId: this.orgId
      }
      this.treeUrl = (this.listProps?.treeUrl != undefined) ? this.listProps?.treeUrl : null
      this.async = (this.listProps?.async != undefined) ? this.listProps?.async : true
    },
    // 默认为选人接口
    getDefaultUrl () {
      return this.showPage ? 'api-general/module/portal/user/listOrganizationUser' : 'module/user/listOrganizationUserAll'
    },
    // 默认为选人接口数据
    getDefaultListData (item) {
      if (this.listProps.sendListData) {
        return this.listProps.sendListData(item.id, this.userName)
      }
      return this.listProps?.listData ? this.listProps?.listData : Object.assign(this.listData, {
        floatState: 0,
        userName: this.userName,
        orderNumSort: 'asc',
        parentId: item.id,
        drillType: 1,
        orgCategorys: this.$category.getDZB()
      })
    },
    // 显示模态框
    onShowTree () {
      this.isAccurate = this.isAccurateFun()
      if (this.isAccurate) {
        this.$ajax({
          url: 'module/config/getInfoSafe',
          method: 'GET',
          data: {
            type: 'PARTY_MEMBER'
          }
        }).then(({data}) => {
          // ACCURATE TREE
          if (data.data.infoSafeModel === 'ACCURATE') {
            this.currOrgId = this.orgId
            this.listData = this.getDefaultListData({id: this.currOrgId})
            this.$nextTick(() => {
              this.$methods('authMember', 'onShow')
            })
            return
          }
          this.isAccurate = false
          this.onShowModalTree()
        })
        return
      }
      this.onShowModalTree()
    },
    onShowModalTree () {
      this.userName = ''
      this.initShowSetting()
      if (this.disabled) return
      this.$nextTick(() => {
        this.$methods('Modal', 'open')
      })
    },
    // 确定
    onOK () {
      // selectData为数组
      this.onProcessData(this.selectData)
      this.$methods('Modal', 'close')
    },
    onProcessData (data, type, allData) {
      // data || selectData为数组
      this.$emit('on-change', data[0], data)
      this.$emit('on-change-tree', data[0], data)
      this.isExpand && this.expandParent('term', data, this.props.key)
      // 扩展方法
      if (this.listProps.isAllResult) {
        let arr = []
        if (type && type === 'table' && allData) {
          arr = allData
        } else {
          data.forEach(item => {
            let _obj = this.allResultData.find(pag => pag[this.listMap.value] === item[this.listMap.value])
            arr.push(_obj)
          })
        }
        this.$emit('on-change-all', arr)
      }
    },
    //模态框显示
    visibleModal () {
      this.getConfigPage().then(() => {
        this.showContent = true
        if (Array.isArray(this.value) && this.value.length) { //反显
          this.checkListLable = this.value.map(item => item[this.listMap.title])
          this.checkList = this.showType === 'checkbox' ? this.value.map(item => item[this.listMap.value]) : this.value[0][this.listMap.value]
        }
        // 无树
        (!this.showTree) && this.initTableData()
      })
    },
    //模态框隐藏
    hidedenModal () {
      this.checkList = this.listProps.type === 'checkbox' ? [] : '' // 选择的数据
      this.checkListLable = []
      this.selectData = []
      this.showContent = false
      this.$Modal.remove()
    },
    // tag点击
    onTagClose (v, index) {
      const ind = this.selectData.findIndex(item => (item[this.listMap.value] === this.checkList[index] && item[this.listMap.title] === v))
      this.selectData.splice(ind, 1)
      this.checkList.splice(index, 1)
      this.checkListLable.splice(index, 1)
    },
    // 多选框选人事件
    onCheckBoxChange (data) {
      this.checkListLable = []
      this.selectData = []
      this.checkList = []
      data.map(item => {
        this.checkList.push(item.value)
        this.selectData.push({
          [this.listMap.title]: item.title,
          [this.listMap.value]: item.value
        })
        this.checkListLable.push(item.title)
      })
      if (this.subAllSelectList.every(item => this.checkList.includes(item.value))) {
        this.indeterminate = false
        this.checkAll = true
      } else {
        this.indeterminate = false
        this.checkAll = false
      }
    },
    // 单选框选人事件
    onRadioBoxChange (data) {
      this.selectData = []
      this.selectData.push({
        [this.listMap.title]: data.title,
        [this.listMap.value]: data.value
      })
      this.checkList = data.value
    },
    onPageChange (data) {
      this.currentPage = data
      this.indeterminate = false
      this.checkAll = false
      this.$methods('checkboxComp', 'setValue')
      this.onSearch({}, 'outer')
    },
    onPageSizeChange (data) {
      this.pageSize = data
      this.indeterminate = false
      this.checkAll = false
      this.onSearch({}, 'outer')
    },
    onSearch (params, type) {
      if (!type) {
        this.currentPage = 1
        this.pageSize = 10
      }
      this.getListPageData(params)
    },
    onSelectChange ([node]) {
      this.currentPage = 1
      this.currOrgId = node.id
      this.currOrgName = node.shortName
      this.listData = this.getDefaultListData(node)
      this.subAllSelectList = []
      let orgCategoryText = node?.orgCategory || node?.data?.orgCategory || null
      if (!this.isGrayDutyUser) {
        this.selectSearchMod = (orgCategoryText == this.$category.getDZB() || orgCategoryText == this.$category.getDXZ()) ? this.globalConfig.zbDutyType : this.globalConfig.otherDutyType
      }
      if (Object.keys(this.globalConfig).length && (orgCategoryText != this.$category.getDZB() && orgCategoryText != this.$category.getDXZ()) && this.selectUserSwitch) {
        if (this.selectSearchMod == 'DUTY_USER') {
          this.getListPageData()
        }
        if (this.globalConfig.otherSearch == 1) {
          this.selectSearchMod == 'PARTY_USER' && this.getListPageData()
          this.isCanEmptySearch = true
          return
        }
        this.isCanEmptySearch = false
        return
      }
      this.isCanEmptySearch = true
      this.getListPageData()
    },
    initTableData () {
      this.currOrgId = this.orgId
      this.listData = this.getDefaultListData({id: this.currOrgId})
      this.getListPageData()
    },
    // 全选事件
    handleCheckAll () {
      if (this.indeterminate) {
        this.checkAll = false
      } else {
        this.checkAll = !this.checkAll
      }
      this.indeterminate = false
      if (this.checkAll) {
        this.subAllSelectList.forEach(item => {
          if (this.checkList.includes(item.value)) return
          this.checkListLable.push(item.title)
          this.checkList.push(item.value)
          this.selectData.push({
            [this.listMap.title]: item.title,
            [this.listMap.value]: item.value
          })
        })
        return
      }
      this.indeterminate = false
      this.subAllSelectList.forEach(pag => {
        let ind = this.selectData.findIndex(item => (item[this.listMap.value] === pag.value))
        this.selectData.splice(ind, 1)
        this.checkList.splice(ind, 1)
        this.checkListLable.splice(ind, 1)
      })
    },
    // 获取列表数据
    getListPageData (params) {
      // 如果自定义外部传值列表
      this.oldNoData = cloneDeep(this.pageTips.noData)
      this.pageTips.noData = '搜索中...'
      if (this.listProps.customList) {
        this.setSelectListData(this.listProps.customList)
        return
      }
      const bizLineCode = this.listProps?.bizLineCode || 'YWX01'
      const orgCategorys = bizLineCode == 'YWX01' ? '党支部' : (bizLineCode == 'YWX04' ? '团支部' : bizLineCode == 'YWX03' ? '分工会' : '现地')
      let data = Object.assign(cloneDeep(this.listData), this.showPage ? {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        [this.searchKey]: this.userName
      } : {}, {
        isCurrentDuty: (this.selectUserSwitch && this.selectUserSwitch && (this.selectSearchMod === 'DUTY_USER')) ? 1 : null,
        orderNumSort: (this.selectUserSwitch && this.globalConfig.zbUserOrder === 'COMPLEX') ? 'asc' : null,
        orderNumStrSort: (this.selectUserSwitch && this.globalConfig.zbUserOrder === 'SIMPLE') ? 'asc' : null
      }, params || {}, { orgCategorys: orgCategorys })
      if (this.listProps?.sendAction) {
        this.listProps.sendAction(data).then(data => {
          this.setSelectListData(data.data)
          this.count = data.count
          this.currentPage = data.currentPage
        })
        return
      }
      this.$ajax({
        url: this.listUrl,
        method: this.method,
        data
      }).then(({data}) => {
        this.setSelectListData(data.data)
        this.count = data.count
        this.currentPage = data.currentPage
      })
    },
    // 设置列表数据
    setSelectListData (data) {
      this.subAllSelectList = data.filter(p => {
        return !this.disabledList.includes(p[this.listMap.value])
      }).map(item => {
        let full = item.userCode ? item[this.listMap.title] + ' /（' + item.userCode + '）/ ' + item.orgName : item[this.listMap.title] + ' / ' + item.orgName
        return {
          value: item[this.listMap.value],
          title: item[this.listMap.title],
          fullTitle: this.selectUserSwitch ? full : null
        }
      })
      if (this.checkList && this.subAllSelectList.every(item => this.checkList.includes(item.value))) {
        this.indeterminate = false
        this.checkAll = true
      } else {
        this.indeterminate = false
        this.checkAll = false
      }
      // 所有数据
      if (!this.allResultData || !this.allSelectList.length) {
        this.allResultData = data
      } else {
        data.forEach(item => {
          let isHas = this.allResultData.find(pag => pag[this.listMap.value] === item[this.listMap.value])
          if (!isHas) {
            this.allResultData.push(item)
          }
        })
      }
      // 所有遍历后的数据
      if (!this.allSelectList || !this.allSelectList.length) {
        this.allSelectList = data.map(item => {
          return {
            value: item[this.listMap.value] || item[this.listMap.title],
            title: item[this.listMap.title]
          }
        })
      } else {
        data.forEach(item => {
          let isHas = this.allSelectList.find(pag => pag.value === item[this.listMap.value])
          if (!isHas) {
            this.allSelectList.push({
              value: item[this.listMap.value] || item[this.listMap.title],
              title: item[this.listMap.title]
            })
          }
        })
      }
      this.value && Array.isArray(this.value) && this.value.forEach(item => {
        let isHas = this.allSelectList.find(pag => pag.value === item[this.listMap.value])
        if (!isHas) {
          this.allSelectList.push({
            value: item[this.listMap.value] || item[this.listMap.title],
            title: item[this.listMap.title]
          })
          this.allResultData.push(item)
        }
      })
      if (this.oldNoData) {
        this.$set(this.pageTips, 'noData', cloneDeep(this.oldNoData))
      }
      this.oldNoData = ''
      if (!data.length && (this.selectSearchMod == 'PARTY_USER')) {
        this.$set(this.pageTips, 'noData', '暂无可选人员')
      }
    },
    // 右侧input框搜索
    searchPeople () {
      this.currentPage = 1
      if (!this.userName && this.globalConfig.otherSearch == 2 && this.selectUserSwitch && !this.isCanEmptySearch) {
        return
      }
      this.indeterminate = false
      this.checkAll = false
      if (this.listProps.customList) {
        this.searchResult()
      } else {
        this.getListPageData({ [this.searchKey]: this.userName })
      }
    },
    searchResult () {
      if (!this.oldMemList) {
        this.oldMemList = this.subAllSelectList
      }
      let arr = this.oldMemList
      let result = arr.filter(item => item.title.indexOf(this.userName) > -1)
      this.subAllSelectList = result
    }
  }
}
</script>

<style lang="scss" scoped>
@import "variable/variable.scss";
/deep/ .iv-module-layout {
  padding-bottom: 8px;
}
.inputDisabled {
  /deep/ .ivu-input-group-append {
    display: none !important;
  }
}
.iv-select-wrapper {
  border: 1px solid $iv-border-color;
  border-radius: $iv-border-radius;
}
.iv-select-tree, .iv-select-treelistProps {
  border-right: 1px solid $iv-border-color;
  overflow: auto;
}
.iv-select-tree, .iv-select-list {
  max-width: 100%;
  overflow: auto;
  height: 370px;
}
.iv-select-treelistProps, .iv-select-list {
  max-width: 100%;
}
.iv-select-treelistProps , .iv-select-half {
  max-width: 100%;
  overflow: auto;
  height: 435px;
}
.iv-select-tree, .iv-select-half {
  max-width: 100%;
  overflow: auto;
  max-height: 370px;
  min-height: 320px;
}
/deep/.iv-page-wrapper[class~=iv-page-wrapper] {
  padding-top: 8px !important;
  .iv-page-component {
    padding: 0;

  }
}
</style>